import api from './api';

const BASE = '/monitoring/onboarding-alerts';

export const fetchOnboardingAlerts = () =>
  api.get(`${BASE}/live`).then((r) => r.data);

export const resolveOnboardingStage = ({ customer_id, stage, description }) =>
  api.post(`${BASE}/resolve`, { customer_id, stage, description }).then((r) => r.data);

export const undoOnboardingResolution = (resolutionId) =>
  api.delete(`${BASE}/resolutions/${resolutionId}`).then((r) => r.data);

export const fetchCustomerSupportLogs = (customerId) =>
  api.get(`${BASE}/customers/${customerId}/support-logs`).then((r) => r.data);

export const addCustomerSupportLog = (customerId, description) =>
  api
    .post(`${BASE}/customers/${customerId}/support-logs`, { description })
    .then((r) => r.data);
